<template>

  <div class="app-page-title">
    <div class="page-title-wrapper">
    </div>
  </div>

</template>
<script>
export default {
  name: 't-header',
  props: {
    page: {
      type:Object,
      required: false
    }
  }
}
</script>
